import { playNotificationSound } from './audio';

// 새 메시지 수신 시 소리·데스크톱 알림 (설정값은 호출 측에서 전달)
export const notifyIncomingMessage = (msg, me, settings) => {
    const text = String(msg.message || '');
    const targeted = text.includes(`@[${me.userId}|`) || text.includes(`@${me.username}`) || text.includes('@everyone') || text.includes('@here');

    if (targeted ? settings.mentionSound : settings.messageSound) playNotificationSound(targeted ? 'mention' : 'message');

    const wantsPopup = targeted ? settings.mentionNotify : settings.generalNotify;
    if (!wantsPopup || !(document.hidden || !document.hasFocus())) return targeted;
    if (!('Notification' in window) || Notification.permission !== 'granted') return targeted;

    const title = targeted ? `멘션: ${msg.username}` : msg.username;
    const body = text.startsWith('@@MEDIA_BUNDLE::') ? '(사진/동영상)' : text.replace(/@\[[^|\]]+\|([^\]]+)\]/g, '@$1').slice(0, 200);
    if (navigator.serviceWorker?.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'SHOW_NOTIFICATION', title, body, icon: '/icon-192.png' });
    } else {
        try { new Notification(title, { body, icon: '/icon-192.png' }); } catch {}
    }
    return targeted;
};
